module.exports = __webpack_public_path__ + "static/media/preview.a5fc2f27.png";